<!--调拨单扫码入仓后弹窗入库-带商品标签 -->
<template>
    <div class="warehouseOut" v-loading="dailogLoading">
        <div class="dialog-header" v-if="tcrkType == 1">
            <div>
                <el-button v-if="!isTcrkModel" class="btn-primary" size="small" @click="isTcrkModel = true">同仓入库</el-button>
                <el-input v-if="isTcrkModel" class="search-name" :title="whName" v-model="whName" size="small" disabled style="width: 200px"></el-input>
                <el-select
                    v-if="isTcrkModel"
                    v-model="tcrkShelfSpaceId"
                    :loading="loading"
                    filterable
                    clearable
                    reserve-keyword
                    remote
                    :remote-method="value => tcrkRemoteMethod(value, tcrkWarehouseId)"
                    @visible-change="
                        value => {
                            if (value && tcrkShelfSpaceOptions == 0) tcrkRemoteMethod('', tcrkWarehouseId);
                        }
                    "
                    size="small"
                >
                    <el-option v-for="item in tcrkShelfSpaceOptions" :key="item.ShelfSpaceId" :label="item.ShelfSpaceCode" :value="item.ShelfSpaceId"> </el-option>
                </el-select>
            </div>
            <div v-if="isTcrkModel">
                <el-button size="small" @click="isTcrkModel = false">取消</el-button>
                <el-button class="btn-primary" size="small" @click="tcrkSubmitData">入仓</el-button>
            </div>
        </div>
        <div class="tips" v-if="tcrkType == 1">整单商品入库到同一仓位下</div>
        <div class="warehouseOut-main">
            <div class="table-ctn">
                <el-table :data="goodsList" border style="width: 100%" :header-cell-style="{ background: '#F2F6FC' }">
                    <el-table-column prop="GoodName" label="配件名称"></el-table-column>
                    <el-table-column prop="APCode" label="配件编码"></el-table-column>
                    <el-table-column prop="ToWarehouseName" label="仓库" width="100"></el-table-column>
                    <el-table-column prop="ShelfSpaceId" label="仓位" v-if="!isTcrkModel">
                        <template slot-scope="scope">
                            <el-select
                                v-model="scope.row.ShelfSpaceId"
                                :loading="loading"
                                filterable
                                clearable
                                remote
                                reserve-keyword
                                :remote-method="val => remoteMethod(val, scope.row)"
                                @visible-change="positionVisibleChange($event, scope.row)"
                                v-select-scroll-more="remoteMethodScrollMore"
                                @focus="shelfSpaceFocus(scope.row)"
                                no-data-text="无存放仓位"
                                no-match-text="无存放仓位"
                                size="small"
                            >
                                <el-option
                                    v-for="optionItem in scope.row.ShelfSpacesList"
                                    :key="optionItem.index"
                                    :label="optionItem.ShelfSpaceCode"
                                    :value="optionItem.ShelfSpaceId"
                                >
                                    <span style="display: inline-block; width: 150px">{{ optionItem.ShelfSpaceCode }}</span>
                                    <span>库存:{{ optionItem.Count }}</span>
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Count" label="数量" width="100"></el-table-column>
                </el-table>
            </div>
        </div>
        <div class="dialog-footer" v-if="!isTcrkModel">
            <el-button size="small" @click="cancel" :disabled="dailogLoading">取消</el-button>
            <el-button class="btn-primary" size="small" :disabled="dailogLoading" @click="submitData()">入仓</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['EntpTOId', 'GoodsList'],
    data() {
        return {
            tcrkType: 1,
            dailogLoading: false,
            loading: false,
            PositionList: [],
            goodsList: [],
            // 点击仓位时定位下拉框的下标，用于滚动搜索功能
            firstIndex: 0, // goodsList 的下标
            secoundIndex: 0, // goodsList[firstIndex].GoodsLocationList 的下标
            currentShelfSpaceObj: {}, // 当前的下拉框仓位数据
            isTcrkModel: false,
            whName: '',
            tcrkWarehouseId: '',
            tcrkShelfSpaceOptions: [],
            tcrkShelfSpaceId: ''
        };
    },
    mounted() {
        var that = this;
        that.goodsList = that.GoodsList;
        if (!that.goodsList) {
            that.getOrderDetail();
        } else {
            that.whName = that.goodsList[0].ToWarehouseName;
            that.tcrkWarehouseId = that.goodsList[0].ToWarehouseId;
        }
    },
    methods: {
        getOrderDetail() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetTransInForStoreGoods',
                    data: {
                        TOId: that.EntpTOId
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        that.goodsList = data;
                        that.whName = that.goodsList[0].ToWarehouseName;
                        that.tcrkWarehouseId = that.goodsList[0].ToWarehouseId;
                    } else that.$util.warningMsg('存放商品数据异常');
                });
        },
        // 搜仓位
        searchPosition(obj, warehouseId) {
            let that = this;
            if (!warehouseId || that.loading) return;
            that.loading = true;
            return that.$util
                .getPositionByGId({
                    WarehouseId: warehouseId,
                    ShelfSpaceCode: obj.Key,
                    GoodsId: obj.GoodsId,
                    Page: obj.Page,
                    MustIn: false,
                    Limit: 20
                })
                .then(res => {
                    that.loading = false;
                    if (res.data) {
                        that.PositionList = res.data;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.loading = false;
                });
        },
        //仓位下拉框出现/隐藏时触发
        positionVisibleChange(val, goods) {
            if (!val) return;
            let that = this;
            if (!(goods.ShelfSpacesList && goods.ShelfSpacesList.length > 0)) {
                if (that.PositionList && that.PositionList.length > 0) {
                    that.$set(goods, 'ShelfSpacesList', [...that.PositionList]);
                } else {
                    goods.Key = '';
                    goods.Page = 1;
                    goods.StopLoad = false;
                    that.searchPosition(
                        {
                            Key: '',
                            GoodsId: goods.EntpTempGoodsId,
                            Page: 1
                        },
                        goods.ToWarehouseId
                    ).then(() => {
                        that.$set(goods, 'ShelfSpacesList', [...that.PositionList]);
                    });
                }
            }
        },
        /**
         * 搜索仓位
         * 支持远程搜索和滚动下拉加载更多
         *   通过 val 判断是哪种情况，非空时是远程搜索
         */
        remoteMethod(val, goods) {
            let obj = this.currentShelfSpaceObj;
            if (goods) obj.GoodsId = goods.EntpTempGoodsId;
            if (val) {
                // 远程搜索，重置搜索项
                obj.Key = val;
                obj.Page = 1;
                obj.StopLoad = false;
                obj.ShelfSpacesList = [];
            } else {
                // 下拉加载更多
                obj.Page += 1;
            }
            if (obj.StopLoad) return;

            //提交报错后，page还在最后一页
            let count = obj.ShelfSpacesList.length;
            if(20 * (obj.Page-1) != count)
                return;
          
            this.searchPosition(
                {
                    Key: obj.Key,
                    GoodsId: obj.GoodsId,
                    Page: obj.Page
                },
                obj.ToWarehouseId
            ).then(() => {
                let row = {
                    ...obj,
                    StopLoad: this.PositionList.length < 20,
                    ShelfSpacesList: [...obj.ShelfSpacesList, ...this.PositionList]
                };
                this.currentShelfSpaceObj = row;
                // 覆盖下拉框数据
                this.goodsList.forEach((e1, idx1) => {
                    if (e1.EntpTempGoodsId == this.currentShelfSpaceObj.GoodsId) {
                        this.$set(e1, 'ShelfSpacesList', row.ShelfSpacesList);
                        return;
                    }
                });
            });
        },
        // 仓位下拉框聚焦
        shelfSpaceFocus(goods) {
            this.currentShelfSpaceObj = goods;
            this.currentShelfSpaceObj.GoodsId = goods.EntpTempGoodsId;
        },
        // 仓位下拉框滚动加载
        remoteMethodScrollMore() {
            this.remoteMethod();
        },
        submitData() {
            let that = this;
            let dataList = [];
            for (let i = 0; i < that.goodsList.length; i++) {
                if (!that.goodsList[i].ShelfSpaceId) {
                    that.$util.warningMsg('请选择仓位');
                    return;
                }
                let intCount = Number(that.goodsList[i].Count);
                if (intCount <= 0) {
                    that.$util.warningMsg('入库数量必须大于零');
                    return;
                }
                dataList.push({
                    EntpTempGoodsId: that.goodsList[i].EntpTempGoodsId,
                    Count: intCount,
                    ShelfSpaceId: that.goodsList[i].ShelfSpaceId,
                    LabelIds: that.goodsList[i].LabelIds
                });
            }

            that.dailogLoading = true;
            that.$util
                .axiosPost({
                    url: '/api/EntpTransferOrder/SubmitTransOrderLabelInStorage',
                    data: {
                        TOId: that.EntpTOId,
                        GoodsList: dataList
                    },
                    hideLoading: true
                })
                .then(res => {
                    that.$util.successMsg('入仓成功');
                    that.$emit('closeDialog');
                })
                .catch(() => {
                    this.dailogLoading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        // 同仓入库-入库按钮
        tcrkSubmitData() {
            if (!this.tcrkWarehouseId) {
                this.$util.warningMsg('请选择仓库');
                return;
            }
            if (!this.tcrkShelfSpaceId) {
                this.$util.warningMsg('请选择仓位');
                return;
            }
            let _data = this.goodsList;
            _data.forEach(i1 => {
                i1.ShelfSpaceId = this.tcrkShelfSpaceId;
            });
            this.goodsList = _data;
            this.submitData();
        },
        // 同仓入库搜索仓位
        tcrkRemoteMethod(value, tcrkWarehouseId) {
            if (!tcrkWarehouseId) return;
            let that = this;
            that.loading = true;
            that.$util
                .GetShelfSpacesList({
                    WarehouseId: tcrkWarehouseId,
                    ShelfSpaceCode: value,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: false
                })
                .then(res => {
                    that.loading = false;
                    if (res.data) {
                        that.tcrkShelfSpaceOptions = res.data;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.loading = false;
                });
        }
    }
};
</script>

<style lang="less" scoped>
.table-ctn .el-table {
    margin-bottom: 0;
}

.dialog-header {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tips {
    color: #f00;
    margin-top: 4px;
    margin-left: 4px;
}

.dialog-footer {
    text-align: right;
}

.warehouseOut-main {
    padding: 10px 0;
}
</style>
